// src/pages/BuffetDashPage.jsx

import React, { useEffect, useRef } from "react";
import Phaser from "phaser";

const BuffetDashPage = () => {
  const gameRef = useRef(null);

  useEffect(() => {
    let game;

    class BuffetDashScene extends Phaser.Scene {
      constructor() {
        super("BuffetDashScene");
      }

      preload() {
        const g = this.add.graphics();

        // =========================
        // PLAYER
        // =========================

        g.fillStyle(0xff6b35);
        g.fillRoundedRect(0, 0, 60, 60, 16);
        g.generateTexture("ruko", 60, 60);
        g.clear();

        // =========================
        // SOY SAUCE
        // =========================

        g.fillStyle(0x2d1b12);
        g.fillEllipse(40, 15, 80, 30);
        g.generateTexture("soy", 80, 30);
        g.clear();

        // =========================
        // SUSHI TRAY
        // =========================

        g.fillStyle(0x111111);
        g.fillRoundedRect(0, 0, 90, 30, 6);

        g.fillStyle(0xff8c69);
        g.fillCircle(20, 15, 8);

        g.fillStyle(0xffffff);
        g.fillCircle(45, 15, 8);

        g.fillStyle(0xffd700);
        g.fillCircle(70, 15, 8);

        g.generateTexture("sushiTray", 90, 30);
        g.clear();

        // =========================
        // BOBA
        // =========================

        g.fillStyle(0xd8b48a);
        g.fillRect(10, 0, 30, 50);

        g.fillStyle(0x000000);

        for (let i = 0; i < 6; i++) {
          g.fillCircle(15 + i * 4, 42, 3);
        }

        g.generateTexture("boba", 50, 50);
        g.clear();

        // =========================
        // PLATES
        // =========================

        g.fillStyle(0xffffff);

        for (let i = 0; i < 3; i++) {
          g.fillEllipse(35, 40 - i * 10, 70, 18);
        }

        g.generateTexture("plates", 70, 50);
        g.clear();

        // =========================
        // CART
        // =========================

        g.fillStyle(0x888888);
        g.fillRect(0, 0, 90, 45);

        g.fillStyle(0x222222);
        g.fillCircle(15, 45, 8);
        g.fillCircle(75, 45, 8);

        g.generateTexture("cart", 90, 55);
        g.clear();

        // =========================
        // UFO
        // =========================

        g.fillStyle(0x00ffff);
        g.fillEllipse(40, 20, 80, 30);

        g.fillStyle(0x99ffff);
        g.fillCircle(40, 12, 14);

        g.generateTexture("ufo", 80, 40);
        g.clear();

        // =========================
        // TEMPURA
        // =========================

        g.fillStyle(0xffc857);
        g.fillEllipse(30, 15, 60, 30);

        g.generateTexture("tempura", 60, 30);
        g.clear();

        // =========================
        // LANTERN
        // =========================

        g.fillStyle(0xff4444);
        g.fillCircle(30, 30, 30);

        g.fillStyle(0xffdd88);
        g.fillRect(25, 0, 10, 60);

        g.generateTexture("lantern", 60, 60);
        g.clear();

        // =========================
        // TOKEN PILE
        // =========================

        g.fillStyle(0xffd700);

        for (let i = 0; i < 5; i++) {
          g.fillCircle(12 + i * 10, 20, 10);
        }

        g.generateTexture("tokens", 70, 40);
        g.clear();

        // =========================
        // DRONE
        // =========================

        g.fillStyle(0x999999);
        g.fillRect(10, 10, 60, 25);

        g.fillStyle(0x00ffff);
        g.fillRect(0, 0, 20, 8);
        g.fillRect(60, 0, 20, 8);

        g.generateTexture("drone", 80, 40);
        g.clear();

        // =========================
        // CRAB
        // =========================

        g.fillStyle(0xff5522);
        g.fillEllipse(40, 25, 80, 40);

        g.fillCircle(15, 15, 10);
        g.fillCircle(65, 15, 10);

        g.generateTexture("crab", 80, 50);
        g.clear();
      }

      create() {
        this.gameSpeed = 380;
        this.score = 0;
        this.gameOver = false;
        this.isCrouching = false;
        this.jumpCount = 0;
        this.maxJumps = 2;

        // =========================
        // MOBILE CONTROLS
        // =========================

        this.mobileJump = false;
        this.mobileCrouch = false;

        // =========================
        // BACKGROUND
        // =========================

        this.cameras.main.setBackgroundColor("#070707");

        this.bgLines = [];

        for (let i = 0; i < 20; i++) {
          const line = this.add.rectangle(
            i * 120,
            Phaser.Math.Between(80, 520),
            Phaser.Math.Between(80, 220),
            4,
            0xff3355,
            0.3,
          );

          this.bgLines.push(line);
        }

        // =========================
        // GROUND
        // =========================

        this.floorY = this.scale.height - 140;

        // visual line
        this.add.rectangle(
          this.scale.width / 2,
          this.floorY,
          this.scale.width,
          5,
          0xff3355,
        );

        // actual physics ground
        this.ground = this.add.rectangle(
          this.scale.width / 2,
          this.floorY + 140,
          this.scale.width,
          260,
          0x1a1a1a,
        );

        this.physics.add.existing(this.ground, true);

        // =========================
        // PLAYER
        // =========================

        this.player = this.physics.add.sprite(
          180,
          this.scale.height - 210,
          "ruko",
        );

        // IMPORTANT:
        // anchor from feet instead of center
        this.player.setOrigin(0.5, 1);

        // visual size
        this.player.setDisplaySize(60, 60);

        // gravity
        this.player.setGravityY(1800);

        this.player.setCollideWorldBounds(true);

        // stable collider
        this.player.body.setSize(50, 55);

        this.player.body.setOffset(5, 5);

        // ground collision
        this.physics.add.collider(this.player, this.ground);

        // =========================
        // CINEMATIC CAMERA
        // =========================

        this.cameras.main.startFollow(this.player, true, 0.08, 0.08);

        this.cameras.main.setZoom(1.2);
        this.physics.world.setBounds(0, 0, 5000, this.scale.height);
        this.cameras.main.setBounds(0, 0, 5000, this.scale.height);

        // player stays left-ish‰
        this.cameras.main.followOffset.set(-90, -40);

        // smoother feel
        this.cameras.main.roundPixels = false;

        // =========================
        // INPUTS
        // =========================

        this.cursors = this.input.keyboard.createCursorKeys();

        this.spaceKey = this.input.keyboard.addKey(
          Phaser.Input.Keyboard.KeyCodes.SPACE,
        );
        this.shiftKey = this.input.keyboard.addKey(
          Phaser.Input.Keyboard.KeyCodes.SHIFT,
        );

        // =========================
        // TOUCH CONTROLS
        // =========================

        this.input.on("pointerdown", (pointer) => {
          // LEFT SIDE = JUMP
          if (pointer.x < this.scale.width / 2) {
            this.mobileJump = true;
          }

          // RIGHT SIDE = CROUCH
          else {
            this.mobileCrouch = true;
          }
        });

        this.input.on("pointerup", () => {
          this.mobileCrouch = false;
        });

        // =========================
        // OBSTACLES
        // =========================

        this.obstacles = this.physics.add.group();

        this.physics.add.collider(this.obstacles, this.ground);

        this.physics.add.overlap(
          this.player,
          this.obstacles,
          this.hitObstacle,
          null,
          this,
        );

        // =========================
        // SCORE
        // =========================

        this.scoreText = this.add.text(200, 150, "Score: 0", {
          fontFamily: "Arial",
          fontSize: "34px",
          color: "#ffffff",
          fontStyle: "bold",

          stroke: "#000000",
          strokeThickness: 7,
        });

        this.scoreText.setScrollFactor(0);

        this.scoreText.setDepth(999);

        // =========================
        // TITLE
        // =========================

        this.titleText = this.add
          .text(800, 150, "HIRO'S BUFFET DASH", {
            fontFamily: "Arial",
            fontSize: "30px",
            color: "#ffcc55",
            fontStyle: "bold",

            stroke: "#000000",
            strokeThickness: 6,
          })
          .setOrigin(0.5);

        this.titleText.setScrollFactor(0);

        this.titleText.setDepth(999);

        // =========================
        // CONTROLS
        // =========================

        this.controlsText = this.add
          .text(
            800,
            200,
            "SPACE / ↑ = Jump   •   ↓ = Slide   •   SHIFT = Sprint",
            {
              fontFamily: "Arial",
              fontSize: "18px",
              color: "#bbbbbb",

              stroke: "#000000",
              strokeThickness: 5,
            },
          )
          .setOrigin(0.5);

        this.controlsText.setScrollFactor(0);

        this.controlsText.setDepth(999);

        // =========================
        // OBSTACLE TIMER
        // =========================

        this.spawnTimer = this.time.addEvent({
          delay: 1000,
          callback: this.spawnObstacle,
          callbackScope: this,
          loop: true,
        });
      }

      spawnObstacle() {
        if (this.gameOver) return;

        const floorY = this.scale.height - 140;

        const obstacleTypes = [
          // FLOOR OBSTACLES

          {
            key: "soy",
            y: floorY,
            scale: 1,
            floor: true,
          },

          {
            key: "sushiTray",
            y: floorY,
            scale: 1,
            floor: true,
          },

          {
            key: "boba",
            y: floorY,
            scale: 1,
            floor: true,
          },

          {
            key: "plates",
            y: floorY,
            scale: 1,
            floor: true,
          },

          {
            key: "cart",
            y: floorY,
            scale: 1,
            floor: true,
          },

          {
            key: "tokens",
            y: floorY,
            scale: 1,
            floor: true,
          },

          {
            key: "crab",
            y: floorY,
            scale: 1,
            floor: true,
          },

          // CROUCH OBSTACLES

          {
            key: "ufo",
            y: floorY - 130,
            scale: 1.2,
            floor: false,
          },

          {
            key: "lantern",
            y: floorY - 150,
            scale: 1.1,
            floor: false,
          },

          {
            key: "drone",
            y: floorY - 110,
            scale: 1.15,
            floor: false,
          },

          // AIR

          {
            key: "tempura",
            y: floorY - 220,
            scale: 1,
            floor: false,
          },
        ];

        const selected = Phaser.Utils.Array.GetRandom(obstacleTypes);

        const obstacle = this.obstacles.create(
          this.scale.width + 100,
          selected.y,
          selected.key,
        );

        obstacle.setScale(selected.scale);

        obstacle.setVelocityX(-this.gameSpeed);

        obstacle.body.allowGravity = false;

        obstacle.setImmovable(true);

        // IMPORTANT

        if (selected.floor) {
          obstacle.setOrigin(0.5, 1);
        } else {
          obstacle.setOrigin(0.5, 0.5);
        }

        // DOUBLE SPAWN

        if (Math.random() < 0.18) {
          const second = Phaser.Utils.Array.GetRandom(obstacleTypes);

          const obstacle2 = this.obstacles.create(
            this.scale.width + 320,
            second.y,
            second.key,
          );

          obstacle2.setScale(second.scale);

          obstacle2.setVelocityX(-this.gameSpeed);

          obstacle2.body.allowGravity = false;

          obstacle2.setImmovable(true);

          if (second.floor) {
            obstacle2.setOrigin(0.5, 1);
          } else {
            obstacle2.setOrigin(0.5, 0.5);
          }
        }
      }

      hitObstacle() {
        if (this.gameOver) return;

        this.gameOver = true;

        this.physics.pause();

        this.player.setTint(0xff0000);

        this.add
          .text(
            this.scale.width / 2,
            this.scale.height / 2 - 40,
            "DINNER RUSH DEFEATED YOU",
            {
              fontFamily: "Arial",
              fontSize: "44px",
              color: "#ff4444",
              fontStyle: "bold",
            },
          )
          .setOrigin(0.5);

        this.add
          .text(
            this.scale.width / 2,
            this.scale.height / 2 + 30,
            "Refresh Page To Retry",
            {
              fontFamily: "Arial",
              fontSize: "26px",
              color: "#ffffff",
            },
          )
          .setOrigin(0.5);
      }

      update() {
        if (this.gameOver) return;

        // =========================
        // SCORE
        // =========================

        this.score += this.gameSpeed * 0.0025;

        this.scoreText.setText(`Score: ${Math.floor(this.score)}`);

        // =========================
        // SPEED SCALING
        // =========================

        let targetSpeed = 380 + this.score * 0.35;

        targetSpeed = Math.min(targetSpeed, 900);

        // sprint
        if (this.shiftKey.isDown) {
          targetSpeed += 250;

          this.player.setTint(0xff8844);

          // cinematic speed zoom
          this.cameras.main.zoom = Phaser.Math.Linear(
            this.cameras.main.zoom,
            1.34,
            0.045,
          );
        } else {
          this.cameras.main.zoom = Phaser.Math.Linear(
            this.cameras.main.zoom,
            1.2,
            0.045,
          );

          if (!this.isCrouching && this.jumpCount < 2) {
            this.player.clearTint();
          }
        }

        this.gameSpeed = Phaser.Math.Linear(this.gameSpeed, targetSpeed, 0.12);

        // =========================
        // PLAYER STATE
        // =========================

        const onGround =
          this.player.body.blocked.down || this.player.body.touching.down;

        // =========================
        // RUN ANIMATION
        // =========================

        if (onGround && !this.isCrouching) {
          this.player.y += Math.sin(this.time.now * 0.02) * 0.35;

          this.player.angle = Math.sin(this.time.now * 0.015) * 3;
        }

        // =========================
        // LAND RESET
        // =========================

        if (onGround) {
          this.jumpCount = 0;
        }

        // =========================
        // JUMP INPUT
        // =========================

        const jumpPressed =
          Phaser.Input.Keyboard.JustDown(this.cursors.up) ||
          Phaser.Input.Keyboard.JustDown(this.spaceKey) ||
          this.mobileJump;

        // =========================
        // DOUBLE JUMP
        // =========================

        if (jumpPressed && this.jumpCount < this.maxJumps) {
          // first jump
          if (this.jumpCount === 0) {
            this.player.setVelocityY(-850);

            this.cameras.main.shake(60, 0.0015);
          }

          // second jump
          else {
            this.player.setVelocityY(-780);

            this.player.setTint(0xffdd55);

            this.cameras.main.shake(100, 0.0025);
            this.cameras.main.flash(100, 80, 50, 20, false);

            // spin animation
            this.tweens.add({
              targets: this.player,
              angle: this.player.angle + 360,
              duration: 450,
              ease: "Cubic.easeOut",
            });
          }

          this.jumpCount++;
          this.mobileJump = false;
        }

        // =========================
        // FAST FALL
        // =========================

        if (this.cursors.down.isDown && !onGround) {
          this.player.setVelocityY(1200);
        }

        // =========================
        // CROUCH START
        // =========================

        if (
          (this.cursors.down.isDown || this.mobileCrouch) &&
          onGround &&
          !this.isCrouching
        ) {
          this.isCrouching = true;

          this.player.setScale(1, 0.65);

          this.player.body.setSize(50, 35);

          this.player.body.setOffset(5, 25);

          this.player.setTint(0xffcc88);
        }

        // =========================
        // CROUCH END
        // =========================

        if (
          (!(this.cursors.down.isDown || this.mobileCrouch) || !onGround) &&
          this.isCrouching
        )
          if ((!this.cursors.down.isDown || !onGround) && this.isCrouching) {
            this.isCrouching = false;

            this.player.setScale(1, 1);

            this.player.body.setSize(50, 55);

            this.player.body.setOffset(5, 5);

            this.player.clearTint();
          }

        // =========================
        // LANDING SQUASH
        // =========================

        if (onGround && this.player.body.velocity.y > 0) {
          this.player.setScale(1.1, 0.9);

          this.time.delayedCall(70, () => {
            if (!this.isCrouching) {
              this.player.setScale(1, 1);
            }
          });
        }

        // =========================
        // OBSTACLE UPDATE
        // =========================

        this.obstacles.getChildren().forEach((obstacle) => {
          obstacle.setVelocityX(-this.gameSpeed);

          // UFO FLOAT
          if (obstacle.texture.key === "ufo") {
            obstacle.y += Math.sin(this.time.now * 0.01) * 1.2;
          }

          // LANTERN SWING
          if (obstacle.texture.key === "lantern") {
            obstacle.angle = Math.sin(this.time.now * 0.008) * 12;
          }

          // DRONE FLOAT
          if (obstacle.texture.key === "drone") {
            obstacle.y += Math.sin(this.time.now * 0.02) * 0.8;
          }

          // CRAB WIGGLE
          if (obstacle.texture.key === "crab") {
            obstacle.angle = Math.sin(this.time.now * 0.03) * 8;
          }

          // cleanup
          if (obstacle.x < -250) {
            obstacle.destroy();
          }
        });

        // =========================
        // PARALLAX
        // =========================

        this.bgLines.forEach((line) => {
          line.x -= this.gameSpeed * 0.012;

          line.alpha = 0.2 + Math.sin(this.time.now * 0.002) * 0.1;

          if (line.x < -250) {
            line.x = this.scale.width + 200;
          }
        });

        // =========================
        // HARDER OVER TIME
        // =========================

        this.spawnTimer.delay = Phaser.Math.Clamp(
          1000 - this.score * 0.15,
          350,
          1000,
        );
      }
    }

    const config = {
      type: Phaser.AUTO,

      width: 1600,

      height: 900,

      parent: gameRef.current,

      backgroundColor: "#050505",

      pixelArt: false,

      physics: {
        default: "arcade",

        arcade: {
          gravity: {
            y: 0,
          },

          debug: false,
        },
      },

      scale: {
        mode: Phaser.Scale.FIT,

        autoCenter: Phaser.Scale.CENTER_BOTH,
      },

      scene: BuffetDashScene,
    };

    game = new Phaser.Game(config);

    return () => {
      game.destroy(true);
    };
  }, []);

  return (
    <div
      style={{
        width: "100%",
        height: "calc(100vh - 90px)",
        marginTop: "90px",
        overflow: "hidden",
        background: "#050505",

        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        ref={gameRef}
        style={{
          width: "100%",
          height: "100%",
        }}
      />
    </div>
  );
};

export default BuffetDashPage;
